// Global
import { JSX } from 'react';
import { tv } from 'tailwind-variants';

// Local

// Types
export type RemixIconProps = {
  name: string;
  size?: 'sm' | 'm' | 'md' | 'lg' | 'xl';
  className?: string;
  title?: string;
  'aria-hidden'?: boolean;
  viewBox?: string;
};

const RemixIcon = ({
  name,
  size = 'md',
  className,
  title,
  'aria-hidden': ariaHidden = true,
  viewBox = '0 0 24 24',
}: RemixIconProps): JSX.Element => {
  const iconId = name.startsWith('ri-') ? name : `ri-${name}`;

  const { base } = TAILWIND_VARIANTS({ size, className });

  return (
    <svg
      className={base({ size, className })}
      fill="currentColor"
      aria-hidden={ariaHidden}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
    >
      {title && <title>{title}</title>}
      <use href={`#${iconId}`} />
      {/* Safari fallback (older versions) */}
      <use xlinkHref={`#${iconId}`} />
    </svg>
  );
};

export default RemixIcon;

const TAILWIND_VARIANTS = tv({
  defaultVariants: {
    size: 'md',
  },
  slots: {
    base: ['inline-block', 'flex-shrink-0'],
  },
  variants: {
    size: {
      sm: { base: ['w-4', 'h-4'] },
      m: { base: ['w-5', 'h-5'] },
      md: { base: ['w-6', 'h-6'] },
      lg: { base: ['w-8', 'h-8'] },
      xl: { base: ['w-9', 'h-9'] },
    },
  },
});
